module.exports = __webpack_public_path__ + "img/1f5fa.4495e5f.svg";